/**
 * Crew ▸ Login Accounts (sahip 2026-11-01; ADR 0147): kimin hangi gemide bugün girebileceği, son
 * parolanın gemiye inip inmediği ve hesap işlemleri tek sayfada. İşlem pencereleri Settings ▸
 * Users'ınkilerdir (`setup.users.*`).
 */

export const loginAccountsEn = {
  title: 'Login Accounts',
  description: 'Sign-in e-mails, passwords and where each person can sign in today.',
  info: 'On board, only people serving on that vessel today can sign in, with the e-mail and newest password shown here. Office accounts cannot sign in on board.',
  search: 'Search name or e-mail',
  vessel: 'Vessel',
  allVessels: 'All vessels',
  type: 'Type',
  typeAll: 'All types',
  status: 'Status',
  statusAll: 'All',
  statusActive: 'Active',
  statusDisabled: 'Disabled',
  statusNoLogin: 'No login',
  withoutLogin: 'Show people without login',
  table: 'Login accounts',
  pagination: 'Login accounts pages',
  showing: 'Showing {{from}}–{{to}} of {{total}}',
  columns: {
    name: 'Name',
    email: 'Login e-mail',
    type: 'Type',
    rank: 'Rank / role',
    onBoard: 'On board sign-in',
    password: 'Password',
    status: 'Status',
    actions: 'Actions',
  },
  types: {
    office: 'Office',
    vessel: 'Vessel crew',
    both: 'Office + vessel',
  },
  active: 'Active',
  disabled: 'Disabled',
  noLogin: 'No login',
  totpOn: '2FA on',
  totpOff: '2FA off',
  onBoard: {
    ready: 'Ready on {{vessel}}',
    until: 'Until {{date}}',
    waiting: 'Waiting for {{vessel}} to sync',
    waitingPassword: 'Waiting for {{vessel}} to sync (password set {{time}})',
    waitingChange: 'Waiting for {{vessel}} to sync (account changed {{time}})',
    lastContact: '{{vessel}} last contact {{time}}',
    neverSynced: '{{vessel}} has not synced yet',
    stuck:
      '{{vessel}} has not applied this change (pending since {{time}}; last contact {{contact}}). Check the vessel server.',
    notToday: 'Not on board today',
    joins: 'Joins {{vessel}} on {{date}}',
    accountOnBoard: 'account is on board',
    accountNotOnBoard: 'account not on board yet',
    blocker: {
      noLogin: 'no login',
      disabled: 'account disabled',
      disabledPending: 'account disabled — on board after the next sync',
      noPassword: 'no password',
    },
    signedOff: 'Signed off {{vessel}} on {{date}} — cannot sign in on board from {{from}}',
    signedOffPending:
      'Signed off on {{date}} in the office — {{vessel}} still allows sign-in until it syncs',
    joinsPending:
      'Joins on {{date}} in the office — {{vessel}} still allows sign-in until it syncs',
    disabledPending: 'Disabled in the office — {{vessel}} still allows sign-in until it syncs',
    removed: 'Removed — still on board until {{vessel}} syncs',
    shipDate: "Ship's date {{date}}",
    officeOnly: 'Office only',
    officeOnlyDetail: 'No vessel assignment — cannot sign in on board',
    noServer: '{{vessel}} has no vessel server yet',
    noServerDetail: 'Sign-in on board starts when the vessel server is set up',
    disabled: 'Account disabled — cannot sign in on {{vessel}}',
    noPassword: 'No password — give a new password to sign in on {{vessel}}',
    noPasswordPending:
      'Password cancelled in the office — {{vessel}} still allows sign-in until it syncs',
    noLogin: 'No login — cannot sign in on {{vessel}}',
  },
  password: {
    temporary: 'Temporary password — must change at first sign-in',
    temporaryAt: 'Temporary password set {{time}} — must change at first sign-in',
    cancelled: 'Temporary password cancelled — an admin must give a new password',
    cancelledAt: 'Temporary password cancelled {{time}} — an admin must give a new password',
    byUserOn: 'Changed by user on {{date}}',
    setOn: 'Set on {{date}}',
    set: 'Password set',
  },
  action: {
    newPassword: 'New password',
    changeEmail: 'Change login email',
    resetTotp: 'Turn off 2FA',
    disable: 'Disable',
    enable: 'Enable',
    createLogin: 'Create login',
  },
  actionsOf: 'More actions for {{name}}',
  newPasswordFor: 'New password for {{name}}',
  createLoginFor: 'Create login for {{name}}',
  newPasswordBody:
    '{{name}} gets a new temporary password and must change it at the first sign-in. In the office only the newest password works. On board the old password keeps working until the vessel syncs (a few minutes while it is online) — watch the On board sign-in column.',
  newPasswordNote:
    'In the office only the newest password works. On board the old password keeps working until the vessel syncs (a few minutes while it is online) — watch the On board sign-in column.',
  emptyTitle: 'No login accounts yet',
  emptyText: 'Create a login from a crew card or from Settings › Users.',
  noMatch: 'No account matches the filters.',
  loadError: 'Login accounts could not be loaded.',
  forbiddenTitle: 'No access',
  forbiddenText: 'You need permission to view users to open this page.',
  notice: {
    email: 'Login e-mail of {{name}} changed. On board it applies after the next sync.',
    disabled: '{{name}} can no longer sign in. On board it applies after the next sync.',
    enabled: '{{name}} can sign in again. On board it applies after the next sync.',
    totp: 'Two-step sign-in turned off for {{name}}. They sign in with the password and can turn it on again in Settings ▸ Account.',
    created: 'Login created for {{name}}.',
  },
};

export const loginAccountsTr: typeof loginAccountsEn = {
  title: 'Giriş Hesapları',
  description: 'Giriş e-postaları, parolalar ve herkesin bugün nerede girebileceği.',
  info: 'Gemide yalnız bugün o gemide görevli olanlar, burada görünen e-posta ve en yeni parolayla girebilir. Ofis hesapları gemide giremez.',
  search: 'Ad ya da e-posta ara',
  vessel: 'Gemi',
  allVessels: 'Bütün gemiler',
  type: 'Tür',
  typeAll: 'Bütün türler',
  status: 'Durum',
  statusAll: 'Tümü',
  statusActive: 'Etkin',
  statusDisabled: 'Devre dışı',
  statusNoLogin: 'Hesap yok',
  withoutLogin: 'Hesabı olmayanları da göster',
  table: 'Giriş hesapları',
  pagination: 'Giriş hesapları sayfaları',
  showing: '{{total}} kayıttan {{from}}–{{to}}',
  columns: {
    name: 'Ad',
    email: 'Giriş e-postası',
    type: 'Tür',
    rank: 'Rütbe / rol',
    onBoard: 'Gemide giriş',
    password: 'Parola',
    status: 'Durum',
    actions: 'İşlemler',
  },
  types: {
    office: 'Ofis',
    vessel: 'Gemi personeli',
    both: 'Ofis + gemi',
  },
  active: 'Etkin',
  disabled: 'Devre dışı',
  noLogin: 'Hesap yok',
  totpOn: 'İki adım açık',
  totpOff: 'İki adım kapalı',
  onBoard: {
    ready: '{{vessel}} gemisinde hazır',
    until: '{{date}} tarihine kadar',
    waiting: '{{vessel}} senkronu bekleniyor',
    waitingPassword: '{{vessel}} senkronu bekleniyor (parola {{time}})',
    waitingChange: '{{vessel}} senkronu bekleniyor (hesap değişikliği {{time}})',
    lastContact: '{{vessel}} son bağlantı {{time}}',
    neverSynced: '{{vessel}} henüz senkron yapmadı',
    stuck:
      '{{vessel}} bu değişikliği uygulamadı (bekleyen değişiklik {{time}}; son bağlantı {{contact}}). Gemi sunucusunu kontrol edin.',
    notToday: 'Bugün gemide değil',
    joins: '{{date}} tarihinde {{vessel}} gemisine katılıyor',
    accountOnBoard: 'hesap gemide',
    accountNotOnBoard: 'hesap henüz gemide değil',
    blocker: {
      noLogin: 'hesap yok',
      disabled: 'hesap devre dışı',
      disabledPending: 'hesap devre dışı — gemide bir sonraki senkronla geçerli',
      noPassword: 'parola yok',
    },
    signedOff:
      '{{date}} tarihinde {{vessel}} gemisinden ayrıldı — {{from}} tarihinden itibaren gemide giremez',
    signedOffPending:
      'Ofiste {{date}} tarihinde görevden ayrıldı — {{vessel}} senkron yapana kadar gemide girilebilir',
    joinsPending: 'Ofiste katılış {{date}} — {{vessel}} senkron yapana kadar gemide girilebilir',
    disabledPending: 'Ofiste devre dışı — {{vessel}} senkron yapana kadar gemide girilebilir',
    removed: 'Atama kaldırıldı — {{vessel}} senkron yapana kadar gemide geçerli',
    shipDate: 'Gemi tarihi {{date}}',
    officeOnly: 'Yalnız ofis',
    officeOnlyDetail: 'Gemi ataması yok — gemide giremez',
    noServer: '{{vessel}} gemisinin sunucusu henüz yok',
    noServerDetail: 'Gemide giriş, gemi sunucusu kurulunca başlar',
    disabled: 'Hesap devre dışı — {{vessel}} gemisinde giremez',
    noPassword: 'Parola yok — {{vessel}} gemisinde girmek için yeni parola verin',
    noPasswordPending:
      'Parola ofiste iptal edildi — {{vessel}} senkron yapana kadar gemide girilebilir',
    noLogin: 'Hesap yok — {{vessel}} gemisinde giremez',
  },
  password: {
    temporary: 'Geçici parola — ilk girişte değiştirilmeli',
    temporaryAt: 'Geçici parola {{time}} — ilk girişte değiştirilmeli',
    cancelled: 'Geçici parola iptal edildi — yönetici yeni parola vermeli',
    cancelledAt: 'Geçici parola {{time}} iptal edildi — yönetici yeni parola vermeli',
    byUserOn: '{{date}} tarihinde kişi değiştirdi',
    setOn: '{{date}} tarihinde verildi',
    set: 'Parola var',
  },
  action: {
    newPassword: 'Yeni parola',
    changeEmail: 'Giriş e-postasını değiştir',
    resetTotp: 'İki adımı kapat',
    disable: 'Devre dışı bırak',
    enable: 'Etkinleştir',
    createLogin: 'Giriş hesabı aç',
  },
  actionsOf: '{{name}} için diğer işlemler',
  newPasswordFor: '{{name}} için yeni parola',
  createLoginFor: '{{name}} için giriş hesabı aç',
  newPasswordBody:
    '{{name}} yeni bir geçici parola alır ve ilk girişte değiştirir. Ofiste yalnız en yeni parola geçer. Gemide, gemi senkron yapana dek (internet varken birkaç dakika) eski parola geçer — "Gemide giriş" sütununu izleyin.',
  newPasswordNote:
    'Ofiste yalnız en yeni parola geçer. Gemide, gemi senkron yapana dek (internet varken birkaç dakika) eski parola geçer — "Gemide giriş" sütununu izleyin.',
  emptyTitle: 'Henüz giriş hesabı yok',
  emptyText: 'Personel kartından ya da Ayarlar › Kullanıcılar’dan hesap açın.',
  noMatch: 'Süzgeçlere uyan hesap yok.',
  loadError: 'Giriş hesapları yüklenemedi.',
  forbiddenTitle: 'Erişim yok',
  forbiddenText: 'Bu sayfayı açmak için kullanıcıları görme yetkisi gerekir.',
  notice: {
    email: '{{name}} kişisinin giriş e-postası değişti. Gemide bir sonraki senkronla geçerli olur.',
    disabled: '{{name}} artık giriş yapamaz. Gemide bir sonraki senkronla geçerli olur.',
    enabled: '{{name}} yeniden giriş yapabilir. Gemide bir sonraki senkronla geçerli olur.',
    totp: '{{name}} için iki adımlı giriş kapatıldı. Parolayla girer; isterse Ayarlar ▸ Hesap’tan yeniden açar.',
    created: '{{name}} için giriş hesabı açıldı.',
  },
};
